"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTypeReducer = exports.setErrors = exports.setIsEdited = exports.clearState = exports.updateSelectedEventType = exports.setSelectedEventType = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    selectedEventType: {
        event_type: "",
        display_name: "",
        description: "",
        schema: { fields: [] },
        metadata: {},
    },
    isEdited: false,
    errors: {},
};
var slice = (0, toolkit_1.createSlice)({
    name: "eventTypeState",
    initialState: initialState,
    reducers: {
        setSelectedEventType: function (state, action) {
            state.selectedEventType = action.payload;
        },
        updateSelectedEventType: function (state, action) {
            state.selectedEventType = __assign(__assign({}, state.selectedEventType), action.payload);
            state.isEdited = true;
        },
        clearState: function (state) {
            Object.assign(state, initialState);
        },
        setIsEdited: function (state, action) {
            state.isEdited = action.payload;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
    },
});
var _a = slice.actions, setSelectedEventType = _a.setSelectedEventType, updateSelectedEventType = _a.updateSelectedEventType, clearState = _a.clearState, setIsEdited = _a.setIsEdited, setErrors = _a.setErrors;
exports.setSelectedEventType = setSelectedEventType;
exports.updateSelectedEventType = updateSelectedEventType;
exports.clearState = clearState;
exports.setIsEdited = setIsEdited;
exports.setErrors = setErrors;
var eventTypeReducer = slice.reducer;
exports.eventTypeReducer = eventTypeReducer;
